/*
  Returns an object with mock data to be used when first loading the page.
  This data will be blurred out and replaced by real data before the blur is removed.
*/
export default {
  primaryLinks: [
    {
      name: 'Tasks',
      path: '#'
    },
    {
      name: 'Calendar',
      path: '#'
    },
    {
      name: 'Campaigns',
      path: '#'
    },
    {
      name: 'Drafts',
      path: '#'
    },
    {
      name: 'Ideation',
      path: '#',
      children: [
        {
          name: 'Loading child ideation',
          path: '#'
        }
      ]
    },
    {
      name: 'Content',
      path: '#',
      children: [
        {
          name: 'Loading child content',
          path: '#'
        }
      ]
    },
    {
      name: 'Analytics',
      path: '#'
    },
    {
      name: 'People',
      path: '#',
      children: [
        {
          name: 'Loading child people',
          path: '#'
        }
      ]
    }
  ],
  createLinks: [],
  secondaryLinks: [
    {
      name: 'Loading-a',
      path: '#',
      icon: 'c-chess',
      children: [
        {
          name: 'Loading child a',
          path: '#'
        }
      ]
    },
    {
      name: 'Loading-b',
      path: '#',
      icon: 'c-money',
      children: [
        {
          name: 'Loading child b',
          path: '#'
        }
      ]
    },
    {
      name: 'Loading-c',
      path: '#',
      icon: 'gear',
      children: [
        {
          name: 'Loading child c',
          path: '#'
        }
      ]
    },
    {
      name: 'Loading-d',
      path: '#',
      icon: 'c-question',
      children: [
        {
          name: 'Loading child d',
          path: '#'
        }
      ]
    },
    {
      name: 'Loading-e',
      path: '#',
      icon: 'messages'
    }
  ],
  userLinks: []
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/nav/ia_map_loading.js